import { http } from '../utils/http';
import Paging from '../interfaces/common/paging';
import urlcat from 'urlcat';
import FactorSetOut from '../interfaces/output/factorSetOut';
import FactorSetVersionOut from '../interfaces/output/factorSetVersionOut';
import FactorSetIn from '../interfaces/input/factorSetIn';
import FactorSetVersionIn from '../interfaces/input/factorSetVersionIn';
import DepartureFilters from '../components/factorSets/departure/departureFilter';
import SortFormatterUtils from '../utils/sortFormatterUtils';
import DateTimeUtils from '../utils/dateTimeUtils';

export default class FactorSetCalendarApi {
    static fetchFactorSetCalendarById = async(factorSetId: number, versionId?: number): Promise<FactorSetOut> => {
        const versionQueryString = versionId ? { versionId: versionId } : {};
        const url = urlcat('', `factorsets/calendar/${factorSetId}`, versionQueryString);
        
        const { data } = await http.get<FactorSetOut>(url);

        return data;
    };

    static fetchFactorSetCalendar = async(paging: Paging, filters: DepartureFilters): Promise<Array<FactorSetOut>> => {
        const url = SortFormatterUtils.addSortingToUrl(paging, filters, '/factorsets/calendar');

        const { data } = await http.get<Array<FactorSetOut>>(url);

        return data;
    };

    static fetchFactorSetCalendarVersions = async(factorSetId: number, paging: Paging): Promise<Array<FactorSetVersionOut>> => {
        const url = SortFormatterUtils.addSortingToUrl(paging, null, `/factorsets/calendar/${factorSetId}/versions`);
       
        const { data } = await http.get<Array<FactorSetOut>>(url);

        return data;
    };

    static createFactorSetCalendar = async(factorSet: FactorSetOut): Promise<FactorSetOut> => {
        const newFactorSetCalendar: FactorSetIn = {
            name: factorSet?.name,
            productArenaId: factorSet.productArena?.id,
            unitSubGroupId: factorSet.unitSubGroup?.id,
            productTypeId: factorSet.productType?.id,
            noFactors: true,
            default: factorSet?.default ?? false
        };

        const { data } = await http.post<FactorSetIn, FactorSetOut>('factorsets/calendar', newFactorSetCalendar);

        return data;
    }

    static createCalendarVersion = async(factorSet: FactorSetOut): Promise<FactorSetVersionOut> => {
        const url = `/factorsets/calendar/${factorSet.id}/versions`;

        const newVersion: FactorSetVersionIn = {
            validFromDate: DateTimeUtils.startDateTimeWithTimeZone(factorSet.version?.validFromDate),
            validToDate: DateTimeUtils.endDateTimeWithTimeZone(factorSet.version?.validToDate),
            statusId: 1 //set status to active
        };
        
        const { data } = await http.post<FactorSetVersionIn, FactorSetVersionOut>(url, newVersion);

        return data;
    }

    static updateFactorSetCalendar = async(factorSet: FactorSetOut): Promise<FactorSetOut> => {
        const newFactorSetCalendar: FactorSetIn = {
            name: factorSet.name,
            productArenaId: factorSet.productArena?.id,
            unitSubGroupId: factorSet.unitSubGroup?.id,
            productTypeId: factorSet.productType?.id,
            default: factorSet?.default ?? false
        };
        
        const { data } = await http.put<FactorSetIn, FactorSetOut>(`factorsets/calendar/${factorSet.id}`, newFactorSetCalendar);

        return data;
    }

    static deactivateFactorSetCalendar = async(id: number): Promise<FactorSetOut> => {
        const { data } = await http.delete<FactorSetOut>(`factorsets/calendar/${id}`);

        return data;
    }
}